import { loaderAction, setMasterScheduleFormAction } from "../rootReducer";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { api } from "../../helpers/api";

export const GetScheduleThunk = (args) => async (dispatch, getState) => {
    const { user, currentEstablishment } = getState();

    dispatch(loaderAction(true));

    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('master_id', args.master_id);
        formData.append('establishment', currentEstablishment);
        formData.append('date', args.date || '');

        const response = await api({ data: formData, link: 'get_schedule' });

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            dispatch(setMasterScheduleFormAction(response.data));
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
    }
    finally {
        dispatch(loaderAction(false));
    }
};